<template>
  <div class="sdkBox">
    <h5>云端美育助手第三方SDK目录</h5>
    <p class="title">一、第三方SDK列表</p>
    <table  border="1" >
      <colgroup>
        <col width="111" />
        <col width="57" />
        <col width="57" />
        <col width="228" />
        <col width="170" />
      </colgroup>
      <tbody>
        <tr>
          <td
            class="et5"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              font-weight: 700;
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              background: rgb(238, 238, 238);
              height: 10.5pt;
              width: 83.25pt;
            "
          >
            SDK服务
          </td>
          <td
            class="et5"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              font-weight: 700;
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              background: rgb(238, 238, 238);
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            具体功能
          </td>
          <td
            class="et5"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              font-weight: 700;
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              background: rgb(238, 238, 238);
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            客户端
          </td>
          <td
            class="et5"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              font-weight: 700;
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              background: rgb(238, 238, 238);
              height: 10.5pt;
              width: 171pt;
            "
          >
            获取权限
          </td>
          <td
            class="et5"
            width="170"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              font-weight: 700;
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              background: rgb(238, 238, 238);
              height: 10.5pt;
              width: 127.5pt;
            "
          >
            隐私权政策
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 72.75pt;
              width: 83.25pt;
            "
          >
            支付宝SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 72.75pt;
              width: 42.75pt;
            "
          >
            支付
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 62.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 62.25pt;
              width: 171pt;
            "
          >
            网络状态、Wifi状态、手机状态、读写存储空间、改变Z轴排列任务
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 72.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="https://render.alipay.com/p/f/fd-jm7jym6r/alipay/multi-agreement.html"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            剪贴板
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 72.75pt;
              width: 83.25pt;
            "
          >
            微信支付SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 72.75pt;
              width: 42.75pt;
            "
          >
            支付
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 62.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 62.25pt;
              width: 171pt;
            "
          >
            网络状态、Wifi状态、手机状态、读写存储空间、改变Z轴排列任务
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 72.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="https://weixin.qq.com/cgi-bin/readtemplate?t=weixin_business_pay"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            剪贴板
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 52.5pt;
              width: 83.25pt;
            "
          >
            友盟SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 52.5pt;
              width: 42.75pt;
            "
          >
            统计
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 42pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 42pt;
              width: 171pt;
            "
          >
            网络状态、Wifi状态、手机状态、读写存储空间
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 52.5pt;
              width: 127.5pt;
            "
          >
            <a href="https://www.umeng.com/policy">点击查看第三方隐私政策</a>
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            剪贴板、位置信息、IDFA
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 42pt;
              width: 83.25pt;
            "
          >
            微信分享SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 42pt;
              width: 42.75pt;
            "
          >
            分享
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 31.5pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 31.5pt;
              width: 171pt;
            "
          >
            WIFI状态、手机状态、网络状态
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 42pt;
              width: 127.5pt;
            "
          >
            <a href="https://privacy.qq.com/policy/tencent-privacypolicy"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            剪贴板
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 42pt;
              width: 83.25pt;
            "
          >
            微博分享SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 42pt;
              width: 42.75pt;
            "
          >
            分享
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 31.5pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 31.5pt;
              width: 171pt;
            "
          >
            WIFI状态、手机状态、网络状态
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 42pt;
              width: 127.5pt;
            "
          >
            <a
              href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            剪贴板
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 21.75pt;
              width: 83.25pt;
            "
          >
            乐播SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 21.75pt;
              width: 42.75pt;
            "
          >
            投屏
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 11.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 11.25pt;
              width: 171pt;
            "
          >
            网络权限
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 21.75pt;
              width: 127.5pt;
            "
          >
            <a href="https://www.lebo.cn/mobile/privacy.html?type=1"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            本地网络权限
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
            阿里云SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            一键登录
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
            网络状态、IMSI
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            网络状态、IMSI
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
            七牛SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            文件上传
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
            网络状态、读写存储空间
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a href="https://www.qiniu.com/en/privacy-right"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            网络状态、读写存储空间
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
            腾讯即时通信SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            聊天室
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
            网络状态、相机、麦克风、读写存储空间
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a href="https://cloud.tencent.com/document/product/301/11470"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            网络状态、相机、麦克风、读写存储空间
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
            个推SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            推送
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
      无
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a href="https://www.getui.com/privacy">点击查看第三方隐私政策</a>
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            无
          </td>
        </tr>
         <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
            高德地图
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            地图
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
      定位、电话、存储
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a href="https://lbs.amap.com/pages/privacy/">点击查看第三方隐私政策</a>
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
            定位
          </td>
        </tr>
          <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
          中国移动号码认证SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            移动号码授权登录
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
          查看WLAN连接，读取手机状态和身份
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
          查看WLAN连接，读取手机状态和身份
          </td>
        </tr>
          <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
          中国联通号码认证SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            联通号码授权登录
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
          查看WLAN连接，读取手机状态和身份
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
          查看WLAN连接，读取手机状态和身份
          </td>
        </tr>
          <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
          中国电信号码认证SDK
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            电信号码授权登录
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
          查看WLAN连接，读取手机状态和身份
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.146391.7y9jhqsfz.86.2d155e3bbHRayX"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
          查看WLAN连接，读取手机状态和身份
          </td>
        </tr>
         <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
          ShareSdk
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            分享
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
          读取外置存储卡，写入外部存储卡，检索正在运行的应用
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="https://www.mob.com/about/policy"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
          读取外置存储卡，写入外部存储卡，检索正在运行的应用
          </td>
        </tr>
         <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
          AliFastJson
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            数据解析
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
          无
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
          无
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
          无
          </td>
        </tr>
 <tr>
          <td
            class="et6"
            rowspan="2"
            width="111"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 83.25pt;
            "
          >
          BUGLY
          </td>
          <td
            class="et7"
            rowspan="2"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              
              height: 30.75pt;
              width: 42.75pt;
            "
          >
            APP质量监控以及异常定位分析
          </td>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 42.75pt;
            "
          >
            安卓端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 20.25pt;
              width: 171pt;
            "
          >
          读取外置存储卡，写入外部存储卡
          </td>
          <td
            class="et8"
            rowspan="2"
            width="170"
            style="
              color: rgb(128, 0, 128);
              font-size: 11pt;
              
              text-decoration-line: underline;
              vertical-align: middle;
              white-space: normal;
              
              height: 30.75pt;
              width: 127.5pt;
            "
          >
            <a
              href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
              >点击查看第三方隐私政策</a
            >
          </td>
        </tr>
        <tr>
          <td
            class="et6"
            width="57"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 42.75pt;
            "
          >
            iOS端
          </td>
          <td
            class="et6"
            width="228"
            style="
              color: rgb(0, 0, 0);
              font-size: 9pt;
              
              vertical-align: middle;
              white-space: normal;
              
              height: 10.5pt;
              width: 171pt;
            "
          >
          读取外置存储卡，写入外部存储卡
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.sdkBox{
  position: absolute;
  background: #fff;
  h5{
    font-size:24px;
    line-height:36px;
    text-align: center;
  }
  .title{
    font-size: 12px;
    line-height:18px;
    margin: 12px 0;
  }
}
</style>